import { IComponentOptions, IWindowService } from "angular";
import { StateService } from "@uirouter/angular";
import { GtmhubController } from "@gtmhub/core";
import { formatAttainmentProgressValue } from "@gtmhub/okrs/metrics/utils";
import { IGHGridColumn } from "@gtmhub/shared/components/grid/grid.component";
import { ProfileScreenName } from "../../../models/models";
import { GroupInfo, GroupItem, GroupType } from "../group-details-sidebar.component";

interface IGroupDetailsCellComponentBindings {
  item: GroupItem;
  column: IGHGridColumn;
  groupInfo: GroupInfo;
  screenName: ProfileScreenName;
  formatAttainmentProgressValue(progress: number): number;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface GroupDetailsCellCtrl extends IGroupDetailsCellComponentBindings {}

export class GroupDetailsCellCtrl extends GtmhubController {
  public visibleAssigneesCount = 2;
  static $inject = ["$state", "$window"];

  constructor(private $state: StateService, private $window: IWindowService) {
    super();
    this.formatAttainmentProgressValue = formatAttainmentProgressValue;
  }

  openItemInNewTab(): void {
    const itemURLMap: Record<GroupType, () => string> = {
      metrics: () => this.$state.href("gtmhub.goals.all._metric.metric", { planningSessionId: this.item.sessionId, metricId: this.item.id }),
      goals: () => this.$state.href("gtmhub.goals.all._goalSidebar.goal", { planningSessionId: this.item.sessionId, id: this.item.id }),
    };

    this.$window.open(itemURLMap[this.groupInfo.type](), "_blank");
  }
}

export const GroupDetailsCellComponent: IComponentOptions = {
  bindings: {
    item: "<",
    column: "<",
    groupInfo: "<",
    screenName: "<",
  },
  controller: GroupDetailsCellCtrl,
  template: require("./group-details-cell.component.html"),
};
